let tooltipEl: any = null
const getOrCreateTooltip = (chart: any, bg: any) => {
  tooltipEl = chart?.canvas?.parentNode
  if (tooltipEl) {
    tooltipEl = document.createElement('div')
    tooltipEl.style.background = bg
    tooltipEl.style.borderRadius = '3px'
    tooltipEl.style.minWidth = '120px'
    tooltipEl.style.color = 'white'
    tooltipEl.style.opacity = '1'
    tooltipEl.style.pointerEvents = 'none'
    tooltipEl.style.position = 'absolute'
    tooltipEl.style.transform = 'translate(-50%, 0)'
    tooltipEl.style.transition = 'all .1s ease'
    tooltipEl.style.flexDirection = 'column'
    const table = document.createElement('table')
    table.style.margin = '0px'
    table.style.flexDirection = 'column'

    tooltipEl.appendChild(table)
    chart.canvas.parentNode.appendChild(tooltipEl)
  }

  return tooltipEl
}

export const externalTooltipHandler = (context: any) => {
  const { chart, tooltip } = context
  if (tooltip.opacity === 0) {
    const oldTooltip = chart.canvas.parentNode.getElementsByTagName('div')[0]
    oldTooltip && chart?.canvas?.parentNode?.removeChild(oldTooltip)
    return
  }

  const otherTooltip = chart.canvas.parentNode.getElementsByTagName('div')[0]

  if (otherTooltip) {
    return
  }
  getOrCreateTooltip(chart, tooltip?.dataPoints?.[0].dataset?.backgroundColor ?? '#00000')

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || []
    const bodyLines = tooltip.body.map((b) => b.lines)

    const values = Object.values(bodyLines[0])[0]?.split(':')

    const bName = values[0].replace(/\s+/g, '')
    const status = titleLines[0]

    const tableBody = document.createElement('thead')
    tableBody.style.flexDirection = 'column'
    const span1 = document.createElement('span')
    span1.style.display = 'inline-block'
    span1.style.fontSize = '12px'
    span1.style.fontFamily = 'jiotype-medium'

    const span2 = document.createElement('span')
    span2.style.display = 'inline-block'
    span2.style.fontSize = '12px'
    span2.style.fontFamily = 'jiotype-bold'

    const line = document.createElement('span')
    line.style.background = '#ffffff'
    line.style.borderWidth = '2px'
    line.style.marginRight = '10px'
    line.style.marginBottom = '10px'
    line.style.height = '1px'
    line.style.width = '100%'
    line.style.display = 'inline-block'

    const span3 = document.createElement('span')
    span3.style.display = 'inline-block'
    span3.style.fontSize = '12px'
    span3.style.fontFamily = 'jiotype-medium'
    span3.style.borderTopWidth = '1px'

    const span4 = document.createElement('span')
    span4.style.display = 'inline-block'
    span4.style.fontSize = '12px'
    span4.style.fontFamily = 'jiotype-bold'
    span4.className = `span${bName}${status}`

    const tr1 = document.createElement('tr')
    const tr2 = document.createElement('tr')
    const trLine = document.createElement('tr')
    const tr3 = document.createElement('tr')
    const tr4 = document.createElement('tr')

    const td1 = document.createElement('td')
    const td2 = document.createElement('td')
    const tdLine = document.createElement('td')
    const td3 = document.createElement('td')
    const td4 = document.createElement('td')

    const text1 = values[0]
    const text2 = titleLines[0]
    const text3 = 'Transaction Value'
    const text4 = values[1]
    const view1 = document.createTextNode(text1)
    const view2 = document.createTextNode(text2)
    const view3 = document.createTextNode(text3)
    const view4 = document.createTextNode(text4)

    span1.appendChild(view1)
    span2.appendChild(view2)
    span3.appendChild(view3)
    span4.appendChild(view4)

    td1.appendChild(span1)
    tr1.appendChild(td1)
    tableBody.appendChild(tr1)

    td2.appendChild(span2)
    tr2.appendChild(td2)
    tableBody.appendChild(tr2)

    tdLine.appendChild(line)
    trLine.appendChild(tdLine)
    tableBody.appendChild(trLine)

    td3.appendChild(span3)
    tr3.appendChild(td3)
    tableBody.appendChild(tr3)

    td4.appendChild(span4)
    tr4.appendChild(td4)
    tableBody.appendChild(tr4)

    const tableRoot = tooltipEl?.querySelector('table')

    while (tableRoot?.firstChild) {
      tableRoot.firstChild.remove()
    }

    tableRoot?.appendChild(tableBody)
  }

  const height = tooltipEl?.getBoundingClientRect()?.height ?? 0
  const width = tooltipEl?.getBoundingClientRect()?.width ?? 0

  const positionY = chart?.canvas?.offsetTop
  const positionX = chart?.canvas?.offsetLeft
  const caretY = tooltip?.caretY
  const caretX = tooltip?.caretX

  let top = positionY + caretY - height
  let left = positionX + caretX
  let space = 8

  const yAlign = tooltip?.yAlign
  const xAlign = tooltip?.xAlign

  if (xAlign === 'left') {
    left = left + space * 2 + width / 2
  } else if (xAlign === 'right') {
    left = left - space * 2 - width / 2
  } else if (xAlign === 'center') {
    left = left + space * 2
  }

  if (yAlign === 'top') {
    top += height + space
  } else if (yAlign === 'center') {
    const posY = tooltip.y
    const chartHeight = Number(chart.canvas.style.height.replace('px', ''))
    if (posY < chartHeight / 2) {
      top = posY
    } else {
      top = posY - height + space
    }
  } else if (yAlign === 'bottom') {
    top -= space
    if (xAlign === 'center') {
      top -= space
    }
  }

  if (tooltipEl) {
    tooltipEl.style.opacity = 1
    tooltipEl.style.left = left + 'px'
    tooltipEl.style.top = top + 'px'
    tooltipEl.style.font = tooltip.options.bodyFont.string
    tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px'
  }
}
